import React, {
	useEffect,
	useState
} from 'react'
import classnames 	from 'classnames'
import { connect } 	from 'react-redux'
import {
	CSSTransition
} from 'react-transition-group'
import {
	StaticQuery,
	graphql,
	Link
} from 'gatsby'
import {
	get,
	filter,
	findIndex,
	isFinite,
	isFunction,
	omit
} from 'lodash'

import HeaderMenus 	from '../header-menus'
import withLinks 	from '../with-links'

import { 
	toggleMenu,
	setHasSubMenu
} from '../../redux/actions'

import breakpoints 	from '../../lib/constants/breakpoints.json'
import {
	formatLink
} from '../../lib/formatLink'

import {
	RESIZE,
	SCROLL
} from '../../lib/pubSubEvents'

const subMenuIsTemporary = ({ menuType }) => {
	return menuType === 'dropdown'
}

const findSubMenuForLink = (links, link, forceFixed = false) => {
	return findIndex(links, (o) => {
		const _hasSubLinks = o.subLinks && o.subLinks.length > 0
		return (o.link === link && _hasSubLinks) || (_hasSubLinks && findIndex(o.subLinks, {link: link}) >= 0 && (!forceFixed || !subMenuIsTemporary(o)))
	})
}

const linkHasFixedSubMenu = (links, link) => {
	return findSubMenuForLink(links, link, true) >= 0
}

const HeaderBar = (props) => {
	const {
		height,
		links,
		children,
		activeLink,
		activeParentLink,
		secondary,
		bgColour,
		onClickNavItem
	} = props

	return <div
		className={ classnames('header-bar', {
			'header-bar--secondary': !!secondary,
			[`header-bar--bg-${ bgColour }`]: bgColour
		}) }
		style={{
			height: secondary ? height - 10 : height
		}}
		>
		{ links && links.length > 0 ? <ul>
			{ links.map((_link, _i) => {
				const _hasDropdown = subMenuIsTemporary(_link)
				const _hasSubLinks = _link.subLinks && _link.subLinks.length > 0

				return <li
					key={ _i }
					className={ classnames({
						'header-item--active': _link.link === activeLink || activeParentLink === _i
					}) }
					>
					<Link
						to={ formatLink(_link.link) }
						onClick={ (e) => {
							if(_hasSubLinks && _hasDropdown && onClickNavItem && isFunction(onClickNavItem)){
								e.preventDefault()
								e.stopPropagation()

								onClickNavItem(_i)
							}
						} }
						>
						<span>{ _link.title }</span>
						{ _hasDropdown ? <span className="header-item-dropdown" /> : null }
					</Link>
				</li>
			}) }
		</ul> : null }
		{ children ? children : null }
	</div>
}

const Header = connect(
	(state) => {
		const {
			pages,
			ui
		} = state

	    return {
	    	menuOpen: ui.menuOpen,
	    	hasHamburger: ui.hasHamburger,
	    	headerHeight: ui.headerHeight,
	    	headerColour: ui.headerColour,
			screenSize: ui.screenSize,
			pagesHeaderColours: pages.headerColour
	    }
	}
)((props) => {
	const {
		links,
		dispatch,
		menuOpen,
		hasHamburger,
		headerColour,
		headerHeight,
		pagesHeaderColours,
		screenSize,
		location
	} = props

	const [activeHeader, setActiveHeader] = useState(null)

	useEffect(() => {
		if(activeHeader){
			setActiveHeader(null)
		}
		dispatch(setHasSubMenu(location.pathname, linkHasFixedSubMenu(links, location.pathname)))
	}, [location])

	const activeLink = location.pathname
	const _activeHeader = isFinite(activeHeader) ? activeHeader : findSubMenuForLink(links, activeLink)

	const childLinks = !hasHamburger && isFinite(_activeHeader) && _activeHeader < links.length && links && links[_activeHeader] ? links[_activeHeader].subLinks : null
	const subMenuColour = pagesHeaderColours[activeLink]

	return <header
		className={ classnames({
			'header--menuOpen': menuOpen,
			//[`header--c-${ headerColour }`]: headerColour
		}) }
		>
		<div className="header-nav">
			<HeaderBar
				links={ !hasHamburger ? links : null }
				height={ headerHeight }
				activeLink={ activeLink }
				activeParentLink={ _activeHeader }
				onClickNavItem={ (index) => {
					setActiveHeader(activeHeader === index ? null : index)
				} }
				>
				<Link
					to="/"
					className="header-logo" />
				{ hasHamburger ? <div className="header-hamburger"
					onClick={ (e) => {
						e.preventDefault()
						e.stopPropagation()

						dispatch(toggleMenu(!menuOpen))
					} }
					>
						<div />
						<div />
					</div> : null }
			</HeaderBar>
			{ childLinks && childLinks.length > 0 ? <HeaderBar
				links={ childLinks }
				height={ headerHeight }
				secondary={ true }
				bgColour={ subMenuColour }
				activeLink={ activeLink }
				/> : null }
		</div>
		<HeaderMenus
			links={ links }
			location={ location }
			/>
	</header>
})

export default withLinks(Header)